import { darken } from 'polished'; // <- Função para escurecer a cor
import React from 'react';
import { ButtonProps } from 'react-bootstrap';
import styled from 'styled-components';

interface CustomButtonProps extends ButtonProps {
  label: string;
  onClick?: () => void;
  bgColor?: string; // Cor de fundo personalizada
  textColor?: string; // Cor do texto personalizada
  deactivate?: boolean; // Prop para desativar o botão
}

const StyledButton = styled.button<{
  bgColor?: string;
  textColor?: string;
  deactivate?: boolean;
}>`
  background-color: ${(props) =>
    props.deactivate
      ? darken(0.2, props.bgColor || '#ffffff') // Escurece a cor em 20% se desativado
      : props.bgColor || '#ffffff'};
  color: ${(props) => props.textColor || '#000000'};
  border: none;
  padding: 10px 20px;
  border-radius: 15px;
  cursor: ${(props) => (props.deactivate ? 'not-allowed' : 'pointer')};
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: ${(props) => (props.deactivate ? 'none' : 'scale(1.05)')};
  }

  &:active {
    transform: ${(props) => (props.deactivate ? 'none' : 'scale(0.95)')};
  }

  &:disabled {
    opacity: 0.6;
    filter: grayscale(5%);
  }
`;

const CustomButton: React.FC<CustomButtonProps> = ({
  label,
  onClick,
  bgColor,
  textColor,
  deactivate = false, // Valor padrão false
  ...props
}) => {
  return (
    <StyledButton
      onClick={!deactivate ? onClick : undefined}
      bgColor={bgColor}
      textColor={textColor}
      deactivate={deactivate}
      disabled={deactivate}
      {...props}
    >
      {label}
    </StyledButton>
  );
};

export default CustomButton;
